import React, {useEffect, useState} from "react";
import styled from "styled-components";
import Button from "../common/Button";
import TreeView from "../explorer/TreeView";
import {useStore} from "../../app/store";
import useSWR from "swr";
import 'react-toastify/dist/ReactToastify.css';
import {toast} from "react-toastify";
import {observer} from "mobx-react";
import {ModalBody} from "./Modal";
import Input from "../../components/common/Input";
import {useNavigate} from "react-router-dom";
import {folderFileNameNotAllow} from "../../app/util";

const SaveItemModal = ({
                           entryType,
                           modalTitle,
                           handleCloseModal,
                           modalDepth,
                           saveItem
                       }) => {
    const {appEditorStore, folderStore, confirmStore} = useStore();
    // const specialCharRegex = /[~!@#$%^&*+`={}|\\:;"'<>,.?/]/;
    // const specialCharRegex = /[~!@#$%^&*+`={}\[\]|\\:;"'<>,.?/]/;
    const [inputChkWarn, setInputChkWarn] = useState(false);
    const [inputNameChkWarn, setInputNameChkWarn] = useState(false);
    const [inputSpecialChkWarn, setInputSpecialChkWarn] = useState(false);

    const navigate = useNavigate();
    // const [saveButtonClick, setSaveButtonClick] = useState(false)
    let saveButtonClick = false;

    useEffect(() => {
        return () => {
            folderStore.clearSaveItems();
            folderStore.clearInModal(modalDepth, entryType);
        }
    }, []);
    const {
        data: boardFoldersAndBookmarks,
        isLoadFoldersAndBookmarks,
        mutate: mutateFoldersAndBookmarks
    } = useSWR(`/explorer?type=${entryType}`);
    useEffect(() => {
        if (!isLoadFoldersAndBookmarks && boardFoldersAndBookmarks !== undefined) {
            if (boardFoldersAndBookmarks.status !== "failed") {
                folderStore.setFolderList(entryType, boardFoldersAndBookmarks.data.folders, modalDepth);
                folderStore.setBookmarkList(entryType, boardFoldersAndBookmarks.data.bookmarks);
                folderStore.setCurrentAfterActionInModal(entryType, modalDepth);
            }
        }
    }, [boardFoldersAndBookmarks]);

    const [title, setTitle] = useState(
        entryType === 'PAGE' ? appEditorStore.pageInfo.title : folderStore.getSaveItems().length > 1 ? 'Clipboard Set' :
            appEditorStore.connectedBoardInfoMap[folderStore.getSaveItems().length > 0 && folderStore.getSaveItems()[0].attributes?.attributes['data-id']]?.name
    );

    const onClickSave = async function (force = false) {
        // console.log(saveButtonClick, "saveButtonClick")
        if (!saveButtonClick) {
            saveButtonClick = true;
            let targetPath = folderStore.getCurrentFolderInModal(modalDepth, entryType).path;
            targetPath = targetPath.split(`${entryType},`)[1].slice(0, -1)
            if (!title) {
                setInputChkWarn(true);
                return;
            }
            //
            // title에 특수문자 검사 정규식 하나라도 있으면
            if (folderFileNameNotAllow(title)) {
                setInputSpecialChkWarn(true);
                toast("사용 불가능한 문자가 포함 되어있습니다.");
                return;
            }
            try {
                if (entryType === 'PAGE') {
                    appEditorStore.pageInfo.title = title;
                    const page = await appEditorStore.savePage(targetPath, force);
                    const parentPath = folderStore.getCurrent('PAGE', modalDepth).path
                    navigate('/editor', {
                        state: {fileId: page.file, parentPath}
                    });
                } else if (entryType === 'CLIP') {
                    await appEditorStore.saveToClipBoard(targetPath, title, saveItem, force);
                } else if (entryType === 'COMMON') {
                    await appEditorStore.saveToCommonBoard(targetPath, title, saveItem, force);
                } else if (entryType === 'TEMPLATE') {
                    await appEditorStore.saveToTemplateBoard(targetPath, title, saveItem, force);
                }
                await mutateFoldersAndBookmarks();
                handleCloseModal(modalDepth);
                await appEditorStore.deleteTempSave();
                toast(`완료되었습니다.`);
                saveButtonClick = false;
            } catch (e) {
                console.log(e);
                if (e.code === 'ALREADY_EXIST_FILE_NAME') {
                    // setInputNameChkWarn(true);
                    saveButtonClick = false;
                    confirmStore.openConfirm({
                        confirmText: "확인",
                        text: "같은 이름의 파일이 존재합니다.\n덮어쓰시겠습니까?",
                        confirmFunc: async () => {
                            await onClickSave(true);
                            confirmStore.clear();
                        },
                    });
                    return;
                }
                toast(`저장에 실패했습니다.\n${e.message}`);
                handleCloseModal(modalDepth);
            }
        }
    }
    return (
        <ModalBody id={"SaveFolderEditorModal"}>
            <EditSaveFolderWrap className={"modal-container"}>
                <p className={"list-title"}>경로 지정</p>
                <div className={"list-wrap"}>
                    <div className={"contents"}>
                        <h3>즐겨찾기</h3>
                        <div className={"list"}>
                            {
                                folderStore.getBookmarks(entryType).length > 0 ?
                                    <TreeView
                                        treeType={'Bookmark'}
                                        entryType={entryType}
                                        mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                                        isActionModal={true}
                                        modalDepth={modalDepth}
                                    />
                                    : <div className={"no-entry-folder"}>
                                        즐겨찾는 폴더가 없습니다.
                                    </div>
                            }

                        </div>
                    </div>
                    <div className={"contents"}>
                        <h3>
                            {modalTitle}
                        </h3>
                        <div className={"list"}>
                            {
                                folderStore.folders[entryType]?.children &&
                                folderStore.folders[entryType]?.children.length > 0 ?
                                    <TreeView
                                        entryType={entryType}
                                        mutateFoldersAndBookmarks={mutateFoldersAndBookmarks}
                                        isActionModal={true}
                                        modalDepth={modalDepth}
                                    />
                                    : <div className={"no-entry-folder"}>
                                        {`${modalTitle}`}폴더가 없습니다.
                                    </div>
                            }

                        </div>
                    </div>
                </div>
                <div
                    className={`input-wrap ${inputChkWarn ? 'warn-input' : ''} ${inputNameChkWarn ? 'warn-duplicate' : ''} ${inputSpecialChkWarn ? 'warn-spec-input' : ''}`}>
                    <div className={'save-item-title-text-inner'}>
                        {
                            {
                                '클립보드 저장': '클립보드명 입력',
                                '공통보드 저장': '공통보드명 입력',
                                '클립보드 세트 저장': '클립보드명 입력',
                                '페이지 저장': '상세페이지명 입력',
                                '템플릿보드 저장': '템플릿보드명 입력',
                            }[modalTitle]
                        }
                    </div>
                    <Input
                        onChange={(e) => {
                            setTitle(e.target.value);
                            setInputChkWarn(false);
                            setInputNameChkWarn(false);
                            setInputSpecialChkWarn(false);
                        }}
                        placeholder={"untitled"}
                        id={"save-item-title-text"}
                        // label={"이름을 입력해주세요."}
                        value={title || ''}
                    />
                    <div className={"warn-text"}>
                        <p className={"name-info"}>
                            {
                                `${modalTitle} 이름을 입력해주세요.`
                            }
                        </p>
                        <p className={"name-spec-info"}>
                            특수 문자 제거후 입력해 주세요.
                        </p>
                        <p className={"duplicate-info"}>
                            중복된 이름입니다.
                        </p>
                    </div>
                </div>

                <div className="btn-wrap">
                    <Button
                        type={"outline"}
                        size={"l"}
                        text={"취소"}
                        className={"white"}
                        onClickFunc={() => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        type={"fill"}
                        size={"l"}
                        text={"저장"}
                        onClickFunc={async () => {
                            await onClickSave();
                        }}
                    />
                </div>
            </EditSaveFolderWrap>
        </ModalBody>

    );
};

//
// const ModalBody = styled.div`
//
// `;

const EditSaveFolderWrap = styled.article`
    position: relative;
    z-index: 105;
    background-color: #fff;
    padding: 32px;

    .list-title {
        color: #262626;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
        letter-spacing: -0.14px;
        margin-bottom: 16px;
    }

    & .list-wrap {
        border-radius: 4px;
        background-color: #FAFAFA;
        max-height: 320px;
        overflow-y: scroll;

        & .contents {
            display: block;
            padding-bottom: 16px;

            & h3 {
                color: #3B3B3B;
                font-size: 13px;
                font-weight: 500;
                line-height: 18px;
                letter-spacing: -0.13px;
                margin: 0 0 5px 0;
                padding: 20px 16px 0;
            }

            & .star-icon {
                display: none;
            }

            .list {
                .no-entry-folder {
                    text-align: center;
                    padding: 16px 0;
                    color: #B0B0B0;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: -0.12px;
                }
            }
        }

        & .contents + .contents {
            border-top: 1px solid #EEE;
        }
    }

    & .select-move {
        margin: 20px 0 0;
        display: flex;
        align-items: center;
        font-size: 12px;

        & label {
            display: flex;
            align-items: center;
            cursor: pointer;
        }
    }

    div.btn-wrap {
        display: flex;
        align-items: center;
        gap: 0 4px;
        margin-top: 20px;

        button {
            background: #262626;
            color: #fff;
            border: none;
            width: 100%;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            letter-spacing: -0.14px;
            font-size: 14px;

            &:hover {
                border: none;
            }
        }

        button.white {
            border: 1px solid #C8C8C8;
            color: #262626;
            background-color: transparent;
        }
    }

    div.input-wrap {
        margin-bottom: 24px;

        .warn-text {
            display: none;
            margin-top: 4px;

            p {
                display: none;
                color: #E75434;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                letter-spacing: -0.12px;

            }
        }

        &.warn-input {
            input {
                border: 1px solid #E75434;
                box-shadow: 0 0 8px 0 rgba(231, 84, 52, 0.20);
            }

            .warn-text {
                display: block;

                .name-info {
                    display: block;
                }
            }
        }

        &.warn-spec-input {
            input {
                border: 1px solid #E75434;
                box-shadow: 0 0 8px 0 rgba(231, 84, 52, 0.20);
            }

            .warn-text {
                display: block;

                .name-spec-info {
                    display: block;
                }
            }
        }


        &.warn-duplicate {
            input {
                border: 1px solid #E75434;
                box-shadow: 0 0 8px 0 rgba(231, 84, 52, 0.20);
            }

            .warn-text {
                display: block;

                .duplicate-info {
                    display: block;
                }
            }
        }


        .save-item-title-text-inner {
            display: block;
            margin: 32px auto 16px;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            letter-spacing: -0.14px;
            color: #3b3b3b;
        }

        input {
            height: 32px;
            padding: 0 12px;
            font-size: 12px;
            outline: none;
        }
    }


    div.select-move {
        margin: 32px auto;
        display: flex;
        align-items: center;
        font-size: 12px;
        justify-content: space-between;

        .radio-move-wrap {
            display: flex;
            align-items: center;

            .input-radio-wrap {
                position: relative;

                > input {
                    position: absolute;
                    left: -999999px;
                    width: 0;
                    height: 0;

                    &[type="radio"]:checked + label:after {
                        display: block;
                    }
                }

                > label {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                    padding-left: 20px;

                    &::after {
                        content: '';
                        width: 10px;
                        height: 10px;
                        background: #C86733;
                        position: absolute;
                        top: 7px;
                        left: 3px;
                        border-radius: 100%;
                        display: none;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 4px;
                        width: 16px;
                        height: 16px;
                        border: 1px solid #C86733;
                        border-radius: 100%;
                        background: #fff;
                    }
                }
            }

            .input-radio-wrap + .input-radio-wrap {
                margin-left: 16px;
            }
        }
    }
`;

const Dimmer = styled.div`
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Modal = styled.div`

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;


`

const TableDisplay = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 105;
`;

export default observer(SaveItemModal);
